import React from "react"
import PaymentBanner from "@/components/Banners/SubPage/Variants/PaymentBanner"
import DraggableLetters from "@/components/draggableLetters/DraggableLetters"
import HeaderVariant from "@/components/Banners/SubPage/Variants/HeaderVariant"
import CardAndImageVariant from "@/components/Banners/SubPage/Variants/CardAndImageVariant"
import VideoWithButtonToStartFullScreenVideo from "@/components/Banners/SubPage/Variants/VideoWithButtonToStartFullScreenVideo"
import ImageWithButtonToStartBackgroundVideo from "@/components/Banners/SubPage/Variants/ImageWithButtonToStartBackgroundVideo"
import VideoWithButtonToPlay from "@/components/Banners/SubPage/Variants/VideoWithButtonToPlay"
import VideoNoButton from "@/components/Banners/SubPage/Variants/VideoNoButton"
import ImageWithThumbnailVideo from "@/components/Banners/SubPage/Variants/ImageWithThumbnailVideo"

export const BANNER_VARIANTS = {
	TEXT: "TEXT",
	CARD_AND_IMAGE: "CARD_AND_IMAGE",
	DRAGGABLE_LETTERS: "DRAGGABLE_LETTERS",
	VIDEO_NO_BUTTON: "VIDEO_NO_BUTTON",
	VIDEO_WITH_BUTTON_TO_START_FULL_SCREEN_VIDEO: "VIDEO_WITH_BUTTON_TO_START_FULL_SCREEN_VIDEO",
	IMAGE_WITH_BUTTON_TO_START_BACKGROUND_VIDEO: "IMAGE_WITH_BUTTON_TO_START_BACKGROUND_VIDEO",
	IMAGE_WITH_THUMBNAIL_VIDEO: "IMAGE_WITH_THUMBNAIL_VIDEO",
	VIDEO_WITH_BUTTON_TO_PLAY: "VIDEO_WITH_BUTTON_TO_PLAY",
	PAYMENT: "payment",
}

function BannerVariantSwitcher({ data }) {
	const variant = data?.variant?.variant || ""

	switch (variant) {
		case "":
			return <DraggableLetters data={data} />
		case BANNER_VARIANTS.TEXT:
			return <HeaderVariant data={data} />
		case BANNER_VARIANTS.CARD_AND_IMAGE:
			return <CardAndImageVariant data={data} />
		case BANNER_VARIANTS.VIDEO_NO_BUTTON:
			return <VideoNoButton data={data} />
		case BANNER_VARIANTS.VIDEO_WITH_BUTTON_TO_START_FULL_SCREEN_VIDEO:
			return <VideoWithButtonToStartFullScreenVideo data={data} />
		case BANNER_VARIANTS.IMAGE_WITH_BUTTON_TO_START_BACKGROUND_VIDEO:
			return <ImageWithButtonToStartBackgroundVideo data={data} />
		case BANNER_VARIANTS.IMAGE_WITH_THUMBNAIL_VIDEO:
			return <ImageWithThumbnailVideo data={data} />
		case BANNER_VARIANTS.VIDEO_WITH_BUTTON_TO_PLAY:
			return <VideoWithButtonToPlay data={data} />
		case BANNER_VARIANTS.PAYMENT:
			return <PaymentBanner data={data} />
		default:
			return null
	}
}

export default function SubPageBanner({ data }) {
	if (!data) return null

	return <BannerVariantSwitcher data={data} />
}